<template lang="pug">
#PageResultSignalStatus
    //- Header Global
    .change-on-mobile
        button.mobile-only.overlay-button(
            v-on:click="toggleSidebar()"
        )
            .btn-change-menu
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><polyline points="15 18 9 12 15 6"></polyline></svg>
        HeaderGlobal(HeaderGlobalHeading="Signal Status" :HeaderGlobalBreadcrumb="breadcrumb")
    //- banner filter
    ResultFilter
    //- end banner filter
    .box
        header.box__header.no-border.flex.items-center.justify-between
            .header-meta
                h2.subheading Signal Status
            .header-cta
        .box__body.p-4

            template(v-if="load_data_status_signal_status.status === 'loading'")
                Loading(show="true")
            template(v-else)

                .flex.flex-wrap.-mx-4
                    .block.px-4(class="w-full lg:w-4/6")
                        .box-chart.border.rounded(
                            class="lg:p-4"
                            v-if="signal_status.signal_status && (typeof signal_status.signal_status.categories != 'undefined' && signal_status.signal_status.categories.length > 0) && signal_status.signal_status.series.length > 0 && chartLoaded"
                            )
                            highcharts(:options="chartOptions")

                        NoDataAvailable(v-else)

                    .block.p-4(class="w-full lg:w-2/6")
                        .block.mb-4
                            span.text-light 4G
                            h2.monospace
                                | {{ signal_status.summary && signal_status.summary['4G'] ? signal_status.summary['4G'] : '-' }}
                        .block.mb-4
                            span.text-light 3G
                            h2.monospace
                                | {{ signal_status.summary && signal_status.summary['3G'] ? signal_status.summary['3G'] : '-' }}
                        .block.mb-4
                            span.text-light 2G
                            h2.monospace
                                | {{ signal_status.summary && signal_status.summary['2G'] ? signal_status.summary['2G'] : '-' }}

</template>

<script>
import HeaderGlobal from './../../components/HeaderGlobal.vue'
import ResultFilter from './../result/ResultFilter.vue'
import { mapState } from 'vuex';
import Loading from '@/components/Loading.vue';
import NoDataAvailable from '@/components/NoDataAvailable.vue';

export default {
    name: 'SignalStatus',
    components: {
        HeaderGlobal,
        ResultFilter,
        Loading,
        NoDataAvailable,
    },
    props: ['resultGlobalBreadcrumb'],
    data() {
        return {
            breadcrumb: [
                this.resultGlobalBreadcrumb,
                {
                    name: 'Signal Status',
                    url: '/result/signal-status',
                },
            ],

            chartLoaded: false,

            title: '',
            chartType: 'bar',
            seriesColor: '#6fcd98',
            colorInputIsSupported: null,
            chartOptions: {
                chart: {
                    type: 'bar'
                },
                title: {
                    text: null
                },
                xAxis: {
                    categories: [],
                    crosshair: true,
                    // categories: [
                    //     '4G',
                    //     '3G',
                    //     '2G',
                    //     ],
                    title: {
                        text: null
                    }
                },
                yAxis: {
                    title: {
                        text: null
                    },
                },
                tooltip: {
                    headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                    pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                        '<td style="padding:0"><b>{point.y:1f}</b></td></tr>',
                    footerFormat: '</table>',
                    shared: true,
                    useHTML: true
                },
                plotOptions: {
                    column: {
                        pointPadding: 0.2,
                        borderWidth: 0
                    }
                },
                series: [],
                // series: [{
                //     name: 'Average Signal 10/8/20 - 12/12/20',
                //     color: '#6fcd98',
                //     data: [
                //         90,
                //         181,
                //         21,
                //         ],
                // }],
                credits: {
                    enabled: false
                },
            }
        };
    },
    computed: {
        ...mapState([
            'load_data_status_signal_status',
            'signal_status',
        ]),
    },
    watch: {
        signal_status() {
            this.startChart();
        },
        chartLoaded() {},
    },
    methods: {
        toggleSidebar() {
            EventEmit.$emit('toggleSibebar')
        },
        startChart() {
            if (this.signal_status.signal_status && (typeof this.signal_status.signal_status.categories != "undefined" && this.signal_status.signal_status.categories.length > 0) && this.signal_status.signal_status.series.length > 0) {

                this.chartOptions.xAxis.categories = this.signal_status.signal_status.categories;

                this.chartOptions.series = this.signal_status.signal_status.series;

                this.chartLoaded = true;
            }
        },

    },
    mounted() {
        this.startChart();
    },
}
</script>

<style lang="sass">
</style>
